<a class="d-none d-md-inline" [title]="title" [href]="'#' + modalId" data-bs-toggle="modal" [attr.aria-label]="title">
	<app-icon name="it-info-circle" color="black"></app-icon>
	<span class="visually-hidden">{{ title }}</span>
</a>
